import useStyles from '../../styles';
import React from 'react';
import errorIcon from '../../assests/icons/icon-24x24-error.svg';

interface IToastProps {
  title?: string;
  className?: string;
}

const ErrorToast = (props: IToastProps) => {
  const { title, className } = props;
  const { classes } = useStyles();
  return (
    <div
      className={`flex justify-start items-center font-light h-10 rounded ${classes.errorToast} ${className}`}
    >
      <div className="w-14">
        <img
          src={errorIcon}
          className="m-auto w-5"
          alt="icon_here"
        />
      </div>
      <p className="text-body2">{title}</p>
    </div>
  );
};

export default React.memo(ErrorToast);
